module.exports = __webpack_public_path__ + "img/pw.04e7b81a.svg";